import React from "react";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../../Utils/renderField/nullableValue";
import { formatIdBultoSkim } from "../../../../../helpers/formatValues";
import { formatDetalleReproceso } from "../../../../helpers/detalleReproceso";

// De qué se compone una tancada: cada carga con el almacén del que salió, su
// DRC y lo que aportó en seco
export const CargasTancadaDetalle = ({ cargas }) => {
    if (!cargas.length) {
        return (
            <div className="text-center py-2">Esta tancada no tiene cargas</div>
        );
    }

    return (
        <table className="tancadas-turno__cargas-table">
            <thead>
                <tr>
                    <th>Almacén</th>
                    <th>Materia prima</th>
                    <th>Kg húmedos</th>
                    <th>DRC</th>
                    <th>Kg secos</th>
                </tr>
            </thead>
            <tbody>
                {cargas.map((carga) => {
                    const detalleReproceso = formatDetalleReproceso(
                        carga.detalle_reproceso,
                    );

                    return (
                        <tr key={carga.id}>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={carga.almacen && carga.almacen.nombre}
                                >
                                    {carga.almacen && carga.almacen.nombre}
                                    {carga.bulto_skim &&
                                        " - " +
                                            formatIdBultoSkim(carga.bulto_skim)}
                                </NullableValue>
                            </td>
                            <td className="text-center">
                                <NullableValue
                                    value={
                                        carga.almacen &&
                                        carga.almacen.materia_prima
                                    }
                                >
                                    {carga.almacen &&
                                        carga.almacen.materia_prima}
                                </NullableValue>
                            </td>
                            <td
                                className="text-center text-nowrap"
                                title={detalleReproceso}
                            >
                                <RenderKilogramo
                                    value={carga.kg_humedos}
                                    decimalScale={3}
                                />
                            </td>
                            <td className="text-center text-nowrap">
                                {carga.drc === null ? (
                                    <span className="tancadas-turno__badge-sin-drc">
                                        Sin DRC
                                    </span>
                                ) : (
                                    <RenderNumberPercentage
                                        value={carga.drc}
                                        decimalScale={2}
                                    />
                                )}
                            </td>
                            <td
                                className="text-center text-nowrap"
                                title={detalleReproceso}
                            >
                                <NullableValue value={carga.kg_secos}>
                                    <RenderKilogramo
                                        value={carga.kg_secos}
                                        decimalScale={3}
                                    />
                                </NullableValue>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
